export const IGNORED_VOLTAGES = ['Bivolt', 'Sem Tensão Elétrica', 'n/d'];
